import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * "Creating image" spinner panel of the curation share chain. Purely presentational
 * (no inputs/outputs). Part of the dead share chain (no in-app caller).
 */
@Component({
    selector: 'ft-curation-create-progress-ng',
    imports: [TranslateModule],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-curation-create-progress.component.html'
})
export class FtCurationCreateProgressComponent {}
